import React, { Component } from "react";
import { formatAmount } from "../../../../Common/utils";
import Card from "./Card";
import Filters from "../Filters";
import Axios from "axios";
import { client, uri } from "../../../../apollo";
import { PORTAL_REFRESH_TOKEN } from "../graphql";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showFilters: false,
      balance: {
        value: 0,
        hidden: true,
        error: false,
      },
    };
    this.requestBalance = this.requestBalance.bind(this);
    this.handleFiltersButtonClick = this.handleFiltersButtonClick.bind(this);
  }

  handleFiltersButtonClick() {
    const { showFilters } = this.state;
    this.setState({
      showFilters: !showFilters,
    });
  }

  async requestBalance() {
    this.setState({
      balance: {
        ...this.state.balance,
        error: false,
        hidden: true,
      },
    });

    let error = false;
    let hidden = false;
    try {
      const token = sessionStorage.getItem("token");
      const { data } = await client.mutate({
        mutation: PORTAL_REFRESH_TOKEN,
        variables: { token },
      });

      if (!data.refreshToken) {
        throw new Error("401");
      }

      const result = await Axios.get(uri + "/zapi/balance/", {
        headers: {
          Authorization: `JWT ${data.refreshToken.token}`,
        },
      });

      this.setState({
        balance: {
          error,
          hidden,
          value: result.data.balance,
        },
      });
    } catch (e) {
      error = true;
      hidden = String(e).includes("401");
    } finally {
      this.setState({
        balance: {
          ...this.state.balance,
          error,
          hidden,
        },
      });
    }
  }

  componentDidMount() {
    this.requestBalance();
  }

  getPercentage(value, total) {
    if (total === 0 || isNaN(value)) return '0%';
    return Number(((value || 0) * 100) / total).toFixed(2) + '%';
  }

  render() {
    const { showFilters, balance } = this.state;
    const { loading, error, data } = this.props;
    const { consolidated, cancelled, simulations } = data || {};
    const {
      base: consolidatedBase,
      total: consolidatedTotal,
      count: consolidatedCount,
      totalDebit: consolidatedTotalDebit,
      totalCredit: consolidatedTotalCredit,
    } = consolidated || {};
    const {
      base: cancelledBase,
      total: cancelledTotal,
      count: cancelledCount,
      totalDebit: cancelledTotalDebit,
      totalCredit: cancelledTotalCredit,
    } = cancelled || {};
    const { total: simulationsAmount, count: simulationsCount } =
      simulations || {};

    return (
      <div className="header bg-gradient-default pb-8 pt-5 pt-md-8">
        <div className="container-fluid">
          <div className="header-body">
            {!balance.hidden && (
              <div className="row align-items-center justify-content-center">
                <div className="d-flex align-items-center flex-column">
                  <h1 className="text-white d-inline-block mb-0">
                    {balance.error ? "ERRO" : formatAmount(balance.value)}
                  </h1>
                  <div className="d-flex align-items-center">
                    <p className="p-0 m-0 text-white">Saldo disponível</p>
                  </div>
                </div>
              </div>
            )}
            <div className="row align-items-center py-4">
              <div className="col-lg-6 col-7">
                <h6 className="h2 text-white d-inline-block mb-0">Vendas</h6>
                <div>
                  <a
                    href="javascript:void(0)"
                    className="h4 pt-2 text-white"
                    onClick={this.handleFiltersButtonClick}
                  >
                    <i className="fas fa-filter mr-2 text-sm" />
                    Filtrar
                  </a>
                </div>
              </div>
              {showFilters && <Filters />}
            </div>
            <div className="row">
              <div className="col-12 col-lg-9">
                <div className="row">
                  <div className="col">
                    <Card
                      title="Consolidadas"
                      bgColor="bg-success"
                      subtitleCounter={consolidatedCount}
                      rows={[
                        [
                          {
                            color: 'text-success',
                            title: 'Total c/ Taxas',
                            value: formatAmount(consolidatedTotal),
                          },
                          {
                            color: 'text-success',
                            title: 'Total s/ Taxas',
                            value: formatAmount(consolidatedBase),
                          },
                          {
                            color: 'text-info',
                            title: 'Total Agregado',
                            value: formatAmount(
                              consolidatedTotal - consolidatedBase
                            ),
                          }
                        ],
                        [
                          {
                            color: 'text-success',
                            title: 'Total no Crédito',
                            value: this.getPercentage(consolidatedTotalCredit, consolidatedTotal)
                          },
                          {
                            color: 'text-success',
                            title: 'Total no Débito',
                            value: this.getPercentage(consolidatedTotalDebit, consolidatedTotal)
                          },
                        ]
                      ]}
                    />
                  </div>
                  <div className="col">
                    <Card
                      title="Canceladas"
                      bgColor="bg-danger"
                      subtitleCounter={cancelledCount}
                      rows={[
                        [
                          {
                            color: 'text-success',
                            title: 'Total c/ Taxas',
                            value: formatAmount(cancelledTotal),
                          },
                          {
                            color: 'text-success',
                            title: 'Total s/ Taxas',
                            value: formatAmount(cancelledBase),
                          },
                          {
                            color: 'text-info',
                            title: 'Total Agregado',
                            value: formatAmount(
                              cancelledTotal - cancelledBase
                            ),
                          }
                        ],
                        [
                          {
                            color: 'text-success',
                            title: 'Total no Crédito',
                            value: this.getPercentage(cancelledTotalCredit, cancelledTotal)
                          },
                          {
                            color: 'text-success',
                            title: 'Total no Débito',
                            value: this.getPercentage(cancelledTotalDebit, cancelledTotal)
                          },
                        ]
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-3">
                <Card
                  title="Simulações"
                  bgColor="bg-warning"
                  subtitleCounter={simulationsCount}
                  rows={[
                    [
                      {
                        color: 'text-warning',
                        title: 'Total',
                        value: formatAmount(simulationsAmount),
                      }
                    ]
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Header/index.js